import { get as fetch } from '../utils/fetch.util'

export const get = id => fetch(`/v1/regions/${id}/neighborhoods`)
